import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Chip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GenListDropdown from "./genlist/GenListDropdown";
import QuestionTextBlock from "./QuestionTextBlock";

const useStyles = makeStyles(() => ({
  pickerRow: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    rowGap: 16,
    columnGap: 16,
    marginBottom: 16,
  },
  pickerDropdown: {
    flex: "0 0 240px",
  },
  pickerSearch: {
    flex: "1 1 200px",
    minWidth: 0,
  },
  pickerList: {
    maxHeight: 300,
    overflowY: "auto",
    border: "1px solid #ccc",
    borderRadius: 4,
  },
  pickerItem: {
    padding: "8px 12px",
    borderBottom: "1px solid #eee",
  },
  pickerItemHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    gap: 8,
  },
  pickerItemTextWrap: {
    flex: "1 1 auto",
    minWidth: 0,
  },
  pickerItemMetaRow: {
    marginTop: 4,
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    alignItems: "center",
  },
}));

export default function QuestionPickerDialog({
  open,
  questions, // [{id, text/name, description, categoryLabel, expanded, checked, disabled}, ...]
  filterCategory,
  searchText,
  onChangeCategory,
  onChangeSearch,
  onToggleExpandQuestion,
  onToggleCheck,
  onConfirm,
  onClose,
}) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Seleziona domande</DialogTitle>

      <DialogContent>
        {/* filtri picker */}
        <Box className={classes.pickerRow}>
          <Box className={classes.pickerDropdown}>
            <GenListDropdown
              onChange={(e) => onChangeCategory(e.target.value || "")}
              margin="dense"
              label="Categoria"
              listId="quiz-categories"
              value={filterCategory}
              name="picker-category"
              multiple={false}
              lang="it"
              sortByLabel={true}
            />
          </Box>

          <Box className={classes.pickerSearch}>
            <TextField
              label="Cerca domanda"
              variant="standard"
              margin="dense"
              fullWidth
              value={searchText}
              onChange={(e) => onChangeSearch(e.target.value || "")}
            />
          </Box>
        </Box>

        {/* lista domande filtrate */}
        <Box className={classes.pickerList}>
          {questions.map((q) => {
            const qid = q.id;
            const title = q.text ?? q.name ?? "(senza testo)";
            const desc = q.description ?? "";

            return (
              <Box
                key={qid}
                className={classes.pickerItem}
                style={q.disabled ? { opacity: 0.4 } : {}}
              >
                <Box className={classes.pickerItemHeader}>
                  <Box className={classes.pickerItemTextWrap}>
                    <QuestionTextBlock
                      title={title}
                      desc={desc}
                      expanded={q.expanded}
                      onToggleExpand={() => onToggleExpandQuestion(qid)}
                      disabledExpand={q.disabled}
                    />

                    {q.categoryLabel && (
                      <Box className={classes.pickerItemMetaRow}>
                        <Chip size="small" label={q.categoryLabel} />
                      </Box>
                    )}
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-end"
                    style={{ minWidth: 80 }}
                  >
                    <FormControlLabel
                      style={{ marginRight: 0, marginTop: 4 }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={q.checked}
                          disabled={q.disabled}
                          onChange={(e) => onToggleCheck(qid, e.target.checked)}
                        />
                      }
                      label=""
                    />
                  </Box>
                </Box>
              </Box>
            );
          })}

          {questions.length === 0 && (
            <Box p={2}>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{
                  fontStyle: "italic",
                  textAlign: "center",
                }}
              >
                Nessuna domanda trovata
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>

        <Box position="relative" display="inline-flex">
          <Button
            color="primary"
            variant="contained"
            onClick={onConfirm}
            disabled={questions.every((q) => !q.checked)}
          >
            Aggiungi selezionate
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
